import * as classnames from 'classnames'
import * as React from 'react'
import * as uniqid from 'uniqid'

import * as styles from './tooltip.module.css'

enum Color {
  WHITE = 'WHITE',
  BLACK = 'BLACK'
}

enum Position {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM'
}

interface IProps {
  title: React.ReactNode
  children: React.ReactNode
  width?: number
  color?: Color
  position?: Position
}

interface IState {
  id?: string
}

class Tooltip extends React.Component<IProps, IState> {
  public static Color: typeof Color = Color
  public static Position: typeof Position = Position

  constructor(props: IProps) {
    super(props)
    this.state = {}
  }

  public componentDidMount() {
    this.setState({ id: uniqid() })
  }

  public render() {
    const {
      title,
      children,
      width,
      color = Color.BLACK,
      position = Position.TOP
    } = this.props
    const { id } = this.state
    const rootClassNames = classnames(styles.root, {
      [styles.optionColorBlack]: color === Color.BLACK,
      [styles.optionColorWhite]: color === Color.WHITE,
      [styles.optionPositionTop]: position === Position.TOP,
      [styles.optionPositionBottom]: position === Position.BOTTOM,
      [styles.optionNoWidth]: !width
    })

    return (
      <div className={rootClassNames}>
        <div
          aria-describedby={id}
          role="group"
          className={styles.content}
          tabIndex={0}
        >
          {children}
        </div>
        <div
          className={styles.cloudlet}
          style={{ width }}
          id={id}
          role="tooltip"
        >
          {title}
        </div>
      </div>
    )
  }
}

export default Tooltip
